import { gql } from '@apollo/client';

export default gql`
  mutation updateBookingExtras($currency: String!, $bookingReference: String!, $segments: [InputSegment]) {
    updateBookingExtras(currency: $currency, bookingReference: $bookingReference, segments: $segments) {
      reference
      outboundExtras {
        code
        itemRef
      }
      inboundExtras {
        code
        itemRef
      }
    }
  }
`;
